import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { API_BASE } from "../../services/server";
import "./css/login.css";

export default function AcceptInvite() {
  const { token } = useParams();
  const navigate = useNavigate();

  const [info, setInfo] = useState(null);       // { email, company, role }
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);

  useEffect(() => {
    fetch(`${API_BASE}/users/invitations/${token}/`)
      .then(async (res) => {
        if (!res.ok) {
          const data = await res.json().catch(() => ({}));
          throw new Error(data.detail || "Ogiltig eller utgången inbjudan.");
        }
        return res.json();
      })
      .then(setInfo)
      .catch((err) => setError(err.message));
  }, [token]);

  async function handleSubmit(e) {
    e.preventDefault();
    setError("");

    if (password !== confirm) {
      setError("Lösenorden matchar inte.");
      return;
    }
    if (password.length < 8) {
      setError("Lösenordet måste vara minst 8 tecken.");
      return;
    }

    setSubmitting(true);
    try {
      const res = await fetch(`${API_BASE}/users/invitations/${token}/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ password }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data.detail || "Något gick fel.");
      setDone(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setSubmitting(false);
    }
  }

  if (done) {
    return (
      <div className="login-wrapper">
        <div className="login-card">
          <h1>Konto aktiverat</h1>
          <p style={{ marginBottom: 20 }}>Ditt konto är nu aktiverat. Du kan logga in.</p>
          <button className="login-button" onClick={() => navigate("/login")}>
            Gå till inloggning
          </button>
        </div>
      </div>
    );
  }

  if (error && !info) {
    return (
      <div className="login-wrapper">
        <div className="login-card">
          <h1>Ogiltig inbjudan</h1>
          <p style={{ color: "red" }}>{error}</p>
        </div>
      </div>
    );
  }

  if (!info) {
    return (
      <div className="login-wrapper">
        <div className="login-card">
          <p>Laddar…</p>
        </div>
      </div>
    );
  }

  return (
    <div className="login-wrapper">
      <form className="login-card" onSubmit={handleSubmit}>
        <h1>Sätt ditt lösenord</h1>
        <p style={{ marginBottom: 16, color: "#4b5563" }}>
          Du har blivit inbjuden till <strong>{info.company}</strong> som{" "}
          {info.role === "admin" ? "administratör" : "medlem"}.
        </p>

        <div className="login-field">
          <label>Email</label>
          <input value={info.email} disabled />
        </div>

        <div className="login-field">
          <label>Lösenord</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoFocus
            required
          />
        </div>

        <div className="login-field">
          <label>Bekräfta lösenord</label>
          <input
            type="password"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            required
          />
        </div>

        {error && <p style={{ color: "red", margin: "8px 0" }}>{error}</p>}

        <button className="login-button" disabled={submitting}>
          {submitting ? "Aktiverar…" : "Aktivera konto"}
        </button>
      </form>
    </div>
  );
}
